import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="clipboard"
export default class extends Controller {
  static values = { target: String, feedback: String, reset: String };
  static targets = ["trigger", "feedback"];

  copy() {
    navigator.clipboard.writeText(this.targetValue);
  }

  showFeedback() {
    this.triggerTarget.disabled = !this.triggerTarget.disabled;
    this.feedbackTarget.innerText = this.feedbackValue;

    setTimeout(() => {
      this.triggerTarget.disabled = !this.triggerTarget.disabled;
      this.feedbackTarget.innerText = this.resetValue;
    }, 1000);
  }
}
